import { createSelector } from 'reselect';

/**
 * @description reducer state getter
 */
export const getLeadsBenchmarkReducer = ({ dealersInsights }) =>
  dealersInsights.leadsBenchmark;

export const selectLeadsBenchmarkNoDataRenderUpdateAllowed = createSelector(
  [getLeadsBenchmarkReducer],
  ({ noDataRenderUpdateAllowed }) => noDataRenderUpdateAllowed,
);
